import { createFileRoute } from '@tanstack/react-router'
import { DocumentationPage } from '@/components/pages/documentation-page'

export const Route = createFileRoute('/documentation')({
  component: DocumentationPage,
  head: () => ({ meta: [{ title: 'Documentation — mkdn.app' }] }),
})
